module.exports = __webpack_public_path__ + "img/115.1.ec74d0e0.jpg";